import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    consented: 0,
    consentDate: null,
    categories: {
        personal: 0,
        analytics: 0,
    },
    status: 'init',
};

const cookieSlice = createSlice({
    name: 'cookie',
    initialState: initialState,
    reducers: {
        loadCookie: (state, action) =>{
            const {consented, consentDate, categories} = action.payload;
            state.consented = consented;
            state.consentDate = consentDate;
            state.categories = categories;
            state.status = 'success';
        }
    }, 
});

export const {loadCookie} = cookieSlice.actions;
export default cookieSlice.reducer;